export default "__VITE_ASSET__j5nYXDzh__"